import { ReportLayoutComponent } from './report-layout/report-layout.component';

export const components: any[] = [ReportLayoutComponent];

export * from './report-layout/report-layout.component';
